<template>
  <div>
    <div class="myPanel">
      目前QRCode: {{memberUUID}}



    </div>
  </div>
</template>

<script>/**

 **/
import checkInDeclare from "@/views/checkInAdmin/js/checkInDeclare";


export default {
  //name: "index",
  // props: [""],
  data: function () {
    return {
      id: "",
      dataReady: false,
      formData: {
        name: "",
      },
      memberUUID:"",
    };
  },
  methods: {
    async loadData() {
      this.memberUUID=checkInDeclare.GetLocalMemberId();
      // let data=await apiUtil.api_SupplierTODO("12138114-01")

      // this.data=data
    },
    btnTest(){

    }
  },
  mounted() {
    this.loadData()
  },
}
</script>

<style scoped>
  .myPanel{
    max-width:500px;
    margin:0 auto;
  }

  .myButton{
    width:300px;
    color:white;
  }
</style>
